import React, { useState } from 'react';

function AboutMe() {
    const [showMore, setShowMore] = useState(false);

    const handleButtonClick = () => {
        setShowMore(true);
    };

    return (
        <>
            <div id="aboutme" className="aboutMe">
                <div className="container max-w-screen-sm mx-auto py-12 flex flex-col justify-center items-center">
                    <h2 className="font-bold text-red-500 uppercase">about me</h2>
                    <h1 className="font-bold text-2xl text-center">who I am and what I do</h1>
                    <hr className="border-b-2 w-60 my-3 text-center" />
                    <p className="text-center my-3 px-4">Hi, I'm Filip, a developer dedicated to creating exceptional user
                        experiences. I have 7 years of programming and 5 years of web development, specializing in custom
                        systems and avoiding major CMS platforms like Wordpress.</p>
                    {showMore && (
                        <>
                            <p className="my-3 px-4 text-center">In addition to my programming skills, I am also an experienced graphic designer and UI/UX enthusiast, with over 5 years of experience in graphic design and 3 years in 3D graphics. My attention to detail is evident in the 3D models I create customized for games, animations and technical drawings that serve a variety of industries with practical applications.</p>
                            <p className="my-3 px-4 text-center">Although game development is not my primary focus, I do engage in it at times, always trying for boundless creativity and artistic expression in the game dev.</p>
                            <p className="my-3 px-4 text-center">Aside from coding and design, I find joy in server administration Linux environments. My expertise extends to setting up services, configuring VPNs, cloud storage, streaming platforms, and more. With a passion for problem solving, I thrive in server administration, ensuring smooth operations and optimal performance.</p>
                        </>
                    )}
                    {!showMore && (
                        <button onClick={handleButtonClick} className="text-red-500 hover:underline font-bold uppercase">read more</button>
                    )}
                </div>
            </div>
        </>
    );
}

export default AboutMe;